import { gql } from '@apollo/client';
import USER_FRAGMENT from './user';

export default gql`
  fragment SquadFragment on Squad {
    id
    name
    lineFunctionId
    lineFunction {
      id
      line {
        id
        name
        sport
      }
      name
    }
    members {
      ...UserFragment
    }
  }
  ${USER_FRAGMENT}
`;
